import React from 'react';
import SubRoutes from 'components/SubRoutes';
import ListGestaoChips from 'pages/Records/GestaoChips/List';
import NewGestaoChips from 'pages/Records/GestaoChips/New';

export default function GestaoChips(props) {
  const { match, setBreadcrumbs } = props;
  const pages = [
    {
      name: 'GestaoChipsNew',
      path: '/novo',
      component: NewGestaoChips,
    },
    {
      name: 'GestaoChipsList',
      path: '',
      component: ListGestaoChips,
    },
  ];

  return (
    <SubRoutes
      setBreadcrumbs={setBreadcrumbs}
      defaultPage={0}
      pages={pages}
      match={match}
    />
  );
}
